import React from "react";
const PreparingSharing = React.lazy(() => import('./PreparingSharing'));

export const preparingSharingConfig = [
    {
        path: '/apps/drive',
        element: <PreparingSharing />,
        roleAccess: ['PRESHARE.USER']
    },
    {
        path: '/apps/drive/dokumen/tambah',
        element: <PreparingSharing />,
        permittedRole: ['pegawai'],
        roleAccess: ['PRESHARE.USER']
    },
    {
        path: '/apps/drive/:type',
        element: <PreparingSharing />,
        roleAccess: ['PRESHARE.USER']
    },
    {
        path: '/apps/drive/:type/:filter',
        element: <PreparingSharing />,
        roleAccess: ['PRESHARE.USER']
    },
    {
        path: '/apps/drive/:type/detail/:id',
        element: <PreparingSharing />,
        roleAccess: ['PRESHARE.USER']
    },
    {
        path: '/apps/drive/:type/detail/:id/:filter',
        element: <PreparingSharing />,
        roleAccess: ['PRESHARE.USER']
    },
    {
        path: '/apps/drive/:type/edit/:id',
        element: <PreparingSharing />,
        roleAccess: ['PRESHARE.USER', 'PRESHARE.ADMIN', 'PRESHARE.TEMPLATE']
    },
    {
        path: '/apps/drive/:type/edit/:id/:filter',
        element: <PreparingSharing />,
        roleAccess: ['PRESHARE.USER']
    },
    {
        path: '/apps/drive/dokumen-template/tambah',
        element: <PreparingSharing />,
        roleAccess: ['PRESHARE.TEMPLATE', 'PRESHARE.ADMIN']
    },
];